export default __webpack_public_path__ + "static/media/availableEffect.e87228b5.png";